export const UploadSubtitlesMutation = `
mutation($file:Upload!,$language: String!,$vdocipherVideoid:String!){
  UploadSubtitle(file:$file,vdocipherVideoid:$vdocipherVideoid,language:$language){
    success
  }
}`;
